/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChallengeTeam, IDefy } from '../../../modules/sport/interfaces/defy';
//import DefaultImage from '../../../common/components/images/sports/futbol/default.png';
import TeamDefault from '../../../common/components/images/team-default.svg';
import Team2Default from '../../../common/components/images/team2-default.svg';
import Image from '../../../common/Image';
import { formatPrice } from '../../../utils';
import PaymentLabels from '../modules/sports/PaymentLabelsLeft';
import CoverImg from '../../../common/components/images/challenges/fondo.jpg';
import EscudoAzul from '../../../common/components/images/challenges/sm-escudo-azul.png';
import Loading from '../../loading/LoadingDefy';
import EscudoRojo from '../../../common/components/images/challenges/sm-escudo-rojo.png';
import { Link } from 'react-router-dom';

interface MsjProps {
    detDefy: IDefy;
    timeDefy: boolean;
    dateMatch: any;
    sport: string;
    origin?: string;
    team?: null | ChallengeTeam;
    imageVs?: any;
    teamAuth?: any;
    handlerNext?: any;
}

const getGender = (value: ChallengeTeam) => {
    if (!value) {
        return '';
    }
    switch (value.gender) {
        case 'MIXED':
            return 'Mixto';
        case 'FEMALE':
            return 'Femenino';
        case 'MALE':
            return 'Masculino';

        default:
            return '';
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Defy(props: MsjProps): JSX.Element {
    const { detDefy, timeDefy, dateMatch, sport, origin, team, imageVs, teamAuth, handlerNext } = props;
    let msjchallenger = '';
    let changePendingTeam1 = false;
    let changePendingTeam2 = false;
    let activeClock = true;
    const activeLinAsk = false;
    let challengerTeam = detDefy.challengerTeam; //team1
    let challengedTeam = detDefy.challengedTeam; //team2
    const typeTeam = detDefy.team;
    let activeLinkPayment = false;
    let statusDefy = '';
    let genderNameChallenged = '';
    let genderNameChallenger = '';

    //Buscando Rival ,Desafío en espera de Aceptación, Desafío Confirmado.
    const status = {
        buscando: 'Buscando Rival',
        espera: 'Desafío en espera de Aceptación',
        confirmado: 'Desafío Confirmado',
    };

    if (detDefy) {
        genderNameChallenger = getGender(detDefy.challengerTeam);
        genderNameChallenged = getGender(detDefy.challengedTeam);
        //si es el desafiador
        if (!timeDefy) {
            // Vacío, juego con equipos disponibles
            if (
                (!Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                    !Object.keys(detDefy.challengedTeam).some((x) => x === 'id')) ||
                (Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                    detDefy.challengerTeam.id === null &&
                    Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                    detDefy.challengedTeam.id === null)
            ) {
                if (
                    detDefy.challengedStatus === 'WAITING_TO_ACCEPT' &&
                    detDefy.challengerStatus === 'WAITING_TO_ACCEPT'
                ) {
                    //el desafío es abierto y esta pendiente por aceptar
                    //no importa quien lo abra este estatus muestra el loandig de buscando equipo
                    if (team) {
                        //solo si viene a confirmar tomo los datos de team del profile
                        // si es 1 === challenger, 2 === challenged
                        if (typeTeam === '1') {
                            challengerTeam = team;
                        } else {
                            challengedTeam = team;
                        }
                        msjchallenger = 'Confirma este desafío';
                        statusDefy = status.espera;
                    } else {
                        changePendingTeam1 = true;
                        changePendingTeam2 = true;
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        activeClock = false;
                        msjchallenger = 'Desafia a este equipo';
                        statusDefy = status.buscando;
                    }
                } else {
                    msjchallenger = '  ';
                }
            } else {
                if (
                    // el team1 está disponible
                    (Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                        !Object.keys(detDefy.challengedTeam).some((x) => x === 'id')) ||
                    (Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                        detDefy.challengerTeam.id !== null &&
                        Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                        detDefy.challengedTeam.id === null)
                ) {
                    console.log('************Soy el desafiador challengerParticipate, team2*************');

                    if (detDefy.challengedStatus === 'WAITING_TO_ACCEPT' && detDefy.challengedTeamId == null) {
                        msjchallenger = ''; //' A la espera que acepten...';
                        statusDefy = status.espera;
                        changePendingTeam2 = true;
                    }
                } else if (
                    // el team2 está disponible
                    (!Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                        Object.keys(detDefy.challengedTeam).some((x) => x === 'id')) ||
                    (Object.keys(detDefy.challengerTeam).some((x) => x === 'id') &&
                        detDefy.challengerTeam.id === null &&
                        Object.keys(detDefy.challengedTeam).some((x) => x === 'id') &&
                        detDefy.challengedTeam.id !== null)
                ) {
                    console.log('************Soy el desafiado challengedParticipate*************team1');

                    if (detDefy.challengerStatus === 'WAITING_TO_ACCEPT' && detDefy.challengerTeamId == null) {
                        changePendingTeam1 = true;
                        //el desafiado acepto y espera que responda
                        /*msjchallenger = ' A la espera que el ' + detDefy.challengerTeam.name + ' acepte...';*/
                        msjchallenger = ''; //' A la espera que acepten...';
                    }
                }
                // partidos con estado de listo, falta de pago, empate, ganado o perdido
                else if (detDefy.challengerStatus === 'ACCEPTED' || detDefy.challengedStatus === 'ACCEPTED') {
                    // partido donde no estoy inscripto, pero está pendiente de pago por ambas partes
                    activeLinkPayment = false;
                    if (
                        detDefy.challengerTeam.id !== teamAuth?.id &&
                        detDefy.challengerStatusPaid === 'PENDING_PAYMENT' &&
                        detDefy.challengedTeam.id !== teamAuth?.id &&
                        detDefy.challengedStatusPaid === 'PENDING_PAYMENT'
                    ) {
                        //El  desafiado y el desafiador aceptaron
                        //activeLinkPayment = true;
                        msjchallenger = ' Desafío Completo a la espera de pago';
                        statusDefy = status.confirmado;
                    }

                    //partido donde estoy inscripto, pero estoy falta de pago
                    else if (
                        (detDefy.challengerTeam.id === teamAuth?.id &&
                            detDefy.challengerStatusPaid === 'PENDING_PAYMENT') ||
                        (detDefy.challengedTeam.id === teamAuth?.id &&
                            detDefy.challengedStatusPaid === 'PENDING_PAYMENT')
                    ) {
                        msjchallenger = 'Solo faltas tu para pagar';
                        activeLinkPayment = true;
                        statusDefy = status.confirmado;
                    }
                    //partido donde el desafiado y el desafiador aceptaron, pero falta que el equipo contrario pague
                    else if (
                        (detDefy.challengerTeam.id !== teamAuth?.id &&
                            detDefy.challengerStatusPaid === 'PENDING_PAYMENT') ||
                        (detDefy.challengedTeam.id === teamAuth?.id &&
                            detDefy.challengedStatusPaid === 'PENDING_PAYMENT')
                    ) {
                        msjchallenger =
                            ' A la espera que ' +
                            (detDefy.challengerStatusPaid === 'PENDING_PAYMENT'
                                ? detDefy.challengerTeam.name
                                : detDefy.challengedTeam.name) +
                            ' pague...';
                        activeLinkPayment = false;
                        statusDefy = status.confirmado;
                    } else if (
                        detDefy.challengedStatusPaid === 'PAID_OUT' &&
                        detDefy.challengerStatusPaid === 'PAID_OUT'
                    ) {
                        //El  desafiado y el desafiador aceptaron
                        msjchallenger = 'Desafío Pagado';
                        statusDefy = status.confirmado;
                    }
                }
            }
        } else {
            msjchallenger = 'Tiempo Expirado';
            statusDefy = 'Caducado';
            if (detDefy.challengerStatus === 'ACCEPTED' || detDefy.challengedStatus === 'ACCEPTED') {
                if (
                    (detDefy.challengerTeam.id === teamAuth?.id &&
                        detDefy.challengerStatusPaid === 'PENDING_PAYMENT') ||
                    (detDefy.challengedTeam.id === teamAuth?.id && detDefy.challengedStatusPaid === 'PENDING_PAYMENT')
                ) {
                    msjchallenger = 'Tiempo Expirado, Solo faltas tu para pagar';
                    activeLinkPayment = true;
                }
            }
        }
    }

    if (
        (detDefy.challengerTeam.id === teamAuth?.id && detDefy.challengerStatusPaid !== 'PAID_OUT') ||
        (detDefy.challengedTeam.id === teamAuth?.id && detDefy.challengedStatusPaid !== 'PAID_OUT')
    ) {
        activeLinkPayment = true;
    }

    const InfoDefy = () => {
        return (
            dateMatch &&
            detDefy &&
            sport && (
                <>
                    <h1 className="text-sm-blue-primary font-semibold  text-lg py-3">{statusDefy}</h1>
                    <PaymentLabels
                        title="Amistoso"
                        icon="team"
                        value={`Amistoso ${Math.round(detDefy.reservation.field?.capacity / 2)}x${Math.round(
                            detDefy.reservation.field?.capacity / 2,
                        )}`}
                        sport={sport}
                    />
                    <PaymentLabels title="Fecha" icon="date" value={`${dateMatch.date}`} sport={sport} />
                    <PaymentLabels
                        title="Desde"
                        icon="time"
                        value={`${dateMatch.start} Hrs - ${dateMatch.end} Hrs`}
                        sport={sport}
                    />
                    <PaymentLabels
                        title="Lugar"
                        icon="club"
                        value={`${detDefy.reservation.field?.club?.name}`}
                        sport={sport}
                    />
                    <PaymentLabels
                        title="Dirección"
                        icon="location"
                        value={`${detDefy.reservation.field?.club?.address}`}
                        sport={sport}
                    />
                    <PaymentLabels
                        title="Cancha"
                        icon="date"
                        value={`${detDefy.fieldRealName ? detDefy.fieldRealName : detDefy.reservation.field?.name}`}
                        sport={sport}
                    />
                    <PaymentLabels
                        title="Valor"
                        icon="pay"
                        value={`${formatPrice(detDefy.challengePriceTeam, 0)} por Equipo`}
                        sport={sport}
                    />
                </>
            )
        );
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const InfoClock = () => {
        return (
            detDefy && (
                <>
                    <div className="flex w-full items-center  content-center text-center justify-center  ">
                        <p className="text-center text-white font-semibold py-3 text-lg">
                            {'Tiempo restante para iniciar el partido'}
                        </p>
                    </div>
                    <div className="flex w-full items-center  content-center text-center justify-center  ">
                        <div className="flex w-full md:w-1/2  border-8 mt-6 bg-white shadow-lg rounded-full border-sm-integrate   pt-0 pb-4 px-6 text-center  justify-center content-center ">
                            {/* timeDefy ? (
                                <div className="pt-4">La Fecha para este Partido Termino</div>
                            ) : (
                               <Clock
                                    deadline={detDefy.reservation?.start}
                                    alreadyJoined={false}
                                    alreadyPaid={false}
                                /> 
                            )*/}
                        </div>
                    </div>
                </>
            )
        );
    };

    const IconStatus = (props) => {
        const { statusPaid } = props;
        // console.log({ statusPaid });
        const divCont = `absolute group -top-2 right-3 md:-right-2`;
        const svgClass = `h-10 w-10 md:w-16 md:h-16 absolute top-1/3 right-3 md:right-4  rounded-full border-4`;
        const divContText = `absolute top-0 right-12  w-32 flex-col hidden items-center  mb-14 group-hover:flex`;
        const textClass = `relative z-10  p-2 text-xs leading-none text-white whitespace-no-wrap bg-sm-blue-primary  shadow-lg rounded-md `;
        return statusPaid === 'PAID_OUT' ? (
            <div className={divCont}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${svgClass} bg-green-500 `}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="bevel" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <div className={divContText}>
                    <span className={textClass}>Pago realizado</span>
                </div>
            </div>
        ) : statusPaid === 'PARTIAL_PAYMENT' ? (
            <div className={divCont}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${svgClass}  bg-orange-500 `}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                    />
                </svg>
                <div className={divContText}>
                    <span className={textClass}>Pago el Abono</span>
                </div>
            </div>
        ) : (
            <div className={divCont}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${svgClass} bg-yellow-500`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
                <div className={divContText}>
                    <span className={textClass}>En espera de Pago</span>
                </div>
            </div>
        );
    };

    return (
        <>
            {detDefy && (
                <div className="container z-0  relative  md:w-4/5 mx-auto flex-none md:flex flex-col  border-2 shadow-lg rounded-2xl ">
                    <div className="relative z-20 flex flex-row container w-full py-4 md:py-10   px-1">
                        <Image
                            imgClassName={`absolute z-20 top-28  left-0 right-0  m-auto  p-0 m-0 `}
                            className={`hidden md:block`}
                            src={imageVs}
                            minWidth={null}
                            key={`img-challengesImg-1`}
                            alt="presentation"
                            width={203}
                            height={158}
                        />
                        <Image
                            imgClassName={` absolute z-20 top-20 left-0 right-0  m-auto  p-0 m-0`}
                            className={`block md:hidden`}
                            src={imageVs}
                            minWidth={null}
                            key={`img-challengesImg-2`}
                            alt="presentation"
                            width={80}
                        />
                        <div className="w-1/2 px-0 md:px-0 pb-2 md:pb-0   ">
                            {changePendingTeam1 ? (
                                <>
                                    <Loading handlerNext={() => handlerNext()} />
                                    {/*  <div className="hidden md:block p-6 rounded-md m-2 h-96 ">
                                        <InfoClock />
                                    </div> */}
                                </>
                            ) : (
                                challengerTeam && (
                                    <>
                                        <div
                                            className={`w-full pt-6 flex text-center justify-center content-center items-center`}
                                        >
                                            <div className={`relative flex justify-center`}>
                                                <Image
                                                    imgClassName={`rounded-3xl p-0 m-0 `}
                                                    className={`hidden md:block `}
                                                    src={EscudoAzul}
                                                    minWidth={null}
                                                    key={`img-EscudoAzul-1`}
                                                    alt="presentation"
                                                    width={241}
                                                    height={241}
                                                />
                                                {/* la razon por la cual repito las imagenes es por el alto de la imagen es el responsive */}
                                                <Image
                                                    imgClassName={`rounded-3xl p-0 m-0`}
                                                    className={`block md:hidden w-4/6`}
                                                    src={EscudoAzul}
                                                    minWidth={null}
                                                    key={`img-EscudoAzul-2`}
                                                    alt="presentation"
                                                    width={241}
                                                />
                                                {/* Icono del estado del pago*/}
                                                <IconStatus statusPaid={detDefy.challengerStatusPaid} clas />
                                            </div>
                                        </div>
                                        <div className=" flex text-center justify-center content-center items-center pt-6">
                                            <div className="flex w-96 h-20 text-center justify-center content-center items-center   bg-gray-100 rounded-xl md:rounded-full ">
                                                <p className="flex text-sm-blue-primary italic font-bold text-2xl leading-5">
                                                    {detDefy.challengerTeam?.name}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className={`flex text-center justify-center content-center w-full items-center pt-3 px-1 md:px-0 mb-4`}
                                        >
                                            <Image
                                                imgClassName={`hidden md:block rounded-3xl p-0 m-0`}
                                                className={``}
                                                src={
                                                    detDefy.challengerTeam?.logo
                                                        ? detDefy.challengerTeam?.logo
                                                        : TeamDefault
                                                }
                                                minWidth={null}
                                                key={`img-DefaultImage-1`}
                                                alt="presentation"
                                                height={220}
                                            />
                                            {/* la razon por la cual repito las imagenes es por el alto de la imagen es el responsive */}
                                            <Image
                                                imgClassName={`block md:hidden rounded-3xl p-0 m-0`}
                                                className={``}
                                                src={
                                                    detDefy.challengerTeam?.logo
                                                        ? detDefy.challengerTeam?.logo
                                                        : TeamDefault
                                                }
                                                minWidth={null}
                                                key={`img-DefaultImage-2`}
                                                alt="presentation"
                                                height={120}
                                            />
                                        </div>
                                        <div className="rounded-md m-1 flex text-center justify-center content-center w-full md:w-3/5    mx-auto items-start h-4 border-1  ">
                                            {detDefy.challengerTeam?.level && (
                                                <p className="text-xs md:text-base text-center text-white font-bold leading-3 md:leading-5 border-2 px-2 py-1 rounded-xl">
                                                    Nivel {detDefy.challengerTeam?.level}
                                                </p>
                                            )}
                                            {genderNameChallenger && (
                                                <p className="text-xs md:text-base text-center text-white font-bold leading-3 md:leading-5 border-2 px-2 py-1 rounded-xl">
                                                    Equipo {genderNameChallenger}
                                                </p>
                                            )}
                                        </div>
                                        <div className="rounded-md my-6 flex text-center justify-center content-center w-full md:w-3/5    mx-auto items-start h-32">
                                            {detDefy.challengerTeam && detDefy.challengerTeam.review && (
                                                <p className="text-xs md:text-base text-center text-white font-semibold leading-4 md:leading-5 ">
                                                    {detDefy.challengerTeam?.review}
                                                </p>
                                            )}
                                        </div>
                                    </>
                                )
                            )}
                        </div>
                        <div className="w-1/2  text-center items-center px-0 md:px-0 pb-2 md:pb-0 ">
                            {/*{statusChallenge !== 'PENDING' && */}
                            {changePendingTeam2 ? (
                                <>
                                    <Loading handlerNext={() => handlerNext()} />
                                    {/*  <div className="hidden md:block p-6 rounded-md m-2 h-96 ">
                                        <InfoClock />
                                    </div> */}
                                </>
                            ) : (
                                challengedTeam && (
                                    <>
                                        <div
                                            className={`w-full pt-6 flex text-center justify-center content-center items-center`}
                                        >
                                            <div className={`relative flex justify-center`}>
                                                <Image
                                                    imgClassName={`rounded-3xl p-0 m-0`}
                                                    className={`hidden md:flex`}
                                                    src={EscudoRojo}
                                                    minWidth={null}
                                                    key={`img-EscudoRojo-1`}
                                                    alt="presentation"
                                                    width={241}
                                                    height={241}
                                                />
                                                {/* la razon por la cual repito las imagenes es por el alto de la imagen es el responsive */}
                                                <Image
                                                    imgClassName={`rounded-3xl p-0 m-0`}
                                                    className={`block md:hidden w-4/6`}
                                                    src={EscudoRojo}
                                                    minWidth={null}
                                                    key={`img-EscudoRojo-2`}
                                                    alt="presentation"
                                                    width={241}
                                                />
                                                {/* Icono del estado del pago*/}
                                                <IconStatus statusPaid={detDefy.challengedStatusPaid} />
                                            </div>
                                        </div>
                                        <div className=" flex text-center justify-center content-center items-center pt-6 px-1 md:px-0">
                                            <div className="flex w-full md:w-96 h-20 text-center justify-center content-center items-center   bg-gray-100 rounded-xl md:rounded-full ">
                                                <p className="flex text-sm-blue-primary italic font-bold text-2xl leading-5">
                                                    {detDefy.challengedTeam?.name}{' '}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className={`flex text-center justify-center content-center w-full items-center pt-3 px-1 md:px-0 mb-4`}
                                        >
                                            <Image
                                                imgClassName={`hidden md:block rounded-3xl p-0 m-0`}
                                                className={``}
                                                src={challengedTeam?.logo ? challengedTeam?.logo : Team2Default}
                                                minWidth={null}
                                                key={`img-1`}
                                                alt="presentation"
                                                height={220}
                                            />
                                            {/* la razon por la cual repito las imagenes es por el alto de la imagen es el responsive */}
                                            <Image
                                                imgClassName={`block md:hidden rounded-3xl p-0 m-0`}
                                                className={``}
                                                src={challengedTeam?.logo ? challengedTeam?.logo : Team2Default}
                                                minWidth={null}
                                                key={`img-2`}
                                                alt="presentation"
                                                height={120}
                                            />
                                        </div>
                                        <div className="rounded-md m-1 flex text-center justify-center space-x-2 content-center w-full md:w-3/5    mx-auto items-start h-4  ">
                                            {detDefy.challengedTeam?.level && (
                                                <p className="text-xs md:text-base text-center text-white font-bold leading-3 md:leading-5 border-2 px-2 py-1 rounded-xl">
                                                    Nivel {detDefy.challengedTeam?.level}
                                                </p>
                                            )}
                                            {genderNameChallenged && (
                                                <p className="text-xs md:text-base text-center text-white font-bold leading-3 md:leading-5 border-2 px-2 py-1 rounded-xl">
                                                    Equipo {genderNameChallenged}
                                                </p>
                                            )}
                                        </div>
                                        <div className="rounded-md my-6 flex text-center justify-center content-center  w-full md:w-3/5 mx-auto items-start h-32  ">
                                            {detDefy.challengerTeam && detDefy.challengerTeam.review && (
                                                <p className="text-xs md:text-base text-center text-white font-semibold leading-4 md:leading-5 ">
                                                    {detDefy.challengedTeam?.review}
                                                </p>
                                            )}
                                        </div>
                                        {/* <div className="hidden md:block p-6 rounded-md m-2 h-96 ">
                                            <InfoClock />
                                        </div> */}
                                    </>
                                )
                            )}
                        </div>
                    </div>
                    <div className="block md:hidden z-30  w-full relative flex-row container  py-1 mt-3 md:py-10  bg-gray-300 p-6 px-6  rounded-md h-96 ">
                        <InfoDefy />
                    </div>
                    <div className="hidden md:block bg-gray-300 px-6 py-1 rounded-md mx-2 my-3 md:mx-20 h-96 z-[1] ">
                        <InfoDefy />
                    </div>
                    {/*   <div className="block md:hidden z-30  w-full relative flex-row container  ">
                        <InfoClock />
                    </div> */}
                    <div className="relative z-20 flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                        <div className="w-full text-center content-center items-center">
                            <div className={`text-white text-xl   uppercase py-4 font-extrabold`}>{msjchallenger}</div>
                        </div>
                    </div>

                    <div className="relative z-20 flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                        <div className="w-full text-center content-center items-center">
                            <div className="text-white text-xl   uppercase py-4 font-extrabold my-10">
                                {!timeDefy && activeLinAsk && origin === 'index' && (
                                    <Link
                                        to={`/${sport}/desafiar/equipo/responder/filter?challengeId=${detDefy.id}`}
                                        className="text-sm text-white bg-sm-integrate p-4 rounded-full m-4"
                                        href="/"
                                    >
                                        aceptar desde aqui
                                    </Link>
                                )}
                                {activeLinkPayment && origin === 'index' && (
                                    <Link
                                        to={`/${sport}/desafiar/pago/filter?challengeId=${detDefy.id}`}
                                        className="text-sm text-white bg-sm-integrate  p-4 rounded-full m-5"
                                        href="/"
                                    >
                                        pagar desde aqui
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                    <Image
                        className="z-0 rounded-2xl"
                        src={CoverImg}
                        alt="Fondo"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                    />
                </div>
            )}
        </>
    );
}
